import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

const EnrollmentsRedirect = () => {
  const location = useLocation()

  return (
    <Navigate to='enrollments' state={location.state} replace />
  )
}

export default EnrollmentsRedirect
